export const FileAttachmentIcons = {
  Archive: 'archive.svg',
  Audio: 'audio.svg',
  Default: 'default.svg',
  Image: 'image.svg',
  MsExcel: 'ms-excel.svg',
  MsOneNote: 'ms-one-note.svg',
  MsOutlook: 'ms-outlook.svg',
  MsPowerPoint: 'ms-power-point.svg',
  MsWord: 'ms-word.svg',
  Pdf: 'pdf.svg',
  Text: 'text.svg',
  Video: 'video.svg',
};
